import PageHeaderBar from './PageHeaderBar';

export default PageHeaderBar;
